export enum ConditionType {
  NONE = 'none',
  ATTRIBUTES = 'attributes',
  COUNTRY = 'country'
}
